import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class EllipseConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'width',
			'height',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {
		return {
			width: maximum_rectangle.get_longest_side(),
			height: maximum_rectangle.get_shortest_side(),
		};
	}

	get_labels(): Record<string, string> {
		const { height, width } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			height,
			width,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			height: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			width: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'circular';
	}
}
